var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg001Hospitalbed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_001-hospital_bed",
    "data-name": "001-hospital bed",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.985,
    height: 62.317,
    viewBox: "0 0 65.985 62.317",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7025",
    "data-name": "Group 7025",
    transform: "translate(29.777 9.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7024",
    "data-name": "Group 7024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7023",
    "data-name": "Group 7023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7022",
    "data-name": "Group 7022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7021",
    "data-name": "Group 7021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7020",
    "data-name": "Group 7020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17122",
    "data-name": "Path 17122",
    d: "M246.58,91.468h-4.885V86.583h-5.755v4.885h-4.885v5.755h4.885v4.885h5.755V97.223h4.885Z",
    transform: "translate(-231.054 -86.583)",
    fill: "#00acb1"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7026",
    "data-name": "Group 7026",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17123",
    "data-name": "Path 17123",
    d: "M175.78,48.4A17.088,17.088,0,1,0,158.691,31.31,17.108,17.108,0,0,0,175.78,48.4Zm0-31.6A14.511,14.511,0,1,1,161.269,31.31,14.527,14.527,0,0,1,175.78,16.8Z",
    transform: "translate(-138.24 -14.222)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17124",
    "data-name": "Path 17124",
    d: "M64.7,210.352a7.644,7.644,0,0,0-7.635,7.635v1.753H26.1v-2.455a5.528,5.528,0,0,0-5.522-5.522H8.924V209.5a7.644,7.644,0,0,0-7.635-7.635A1.289,1.289,0,0,0,0,203.152V238.71A1.289,1.289,0,0,0,1.289,240H7.635a1.289,1.289,0,0,0,1.289-1.289v-5.068H57.061v5.068A1.289,1.289,0,0,0,58.349,240H64.7a1.289,1.289,0,0,0,1.289-1.289V211.641A1.289,1.289,0,0,0,64.7,210.352Zm-44.122,3.989a2.948,2.948,0,0,1,2.944,2.944v2.455H8.924v-5.4ZM6.347,237.421H2.578V204.607A5.067,5.067,0,0,1,6.347,209.5Zm2.578-6.357v-8.746H57.061v8.746Zm54.483,6.357H59.638V217.987a5.067,5.067,0,0,1,3.769-4.891Z",
    transform: "translate(0 -177.681)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg001Hospitalbed);
export default __webpack_public_path__ + "static/media/001-hospital bed.e01eafb521655e6d6f259bc2b98ff140.svg";
export { ForwardRef as ReactComponent };